// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profileDetailsHeaderBar {
    width: 90%;
    margin: 0 auto 18px auto;
    display: flex;
    align-items: center;
}

.profileDetailsBackBtn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background-color: #0E1B1B;
    color: #5AAF9A;
    border: 1px solid #1E2D2D;
    border-radius: 10px;
    padding: 9px 18px;
    font-family: "Inter", sans-serif;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}

.profileDetailsBackBtn:hover {
    background-color: #142424;
    color: #48D1CC;
    border-color: #5AAF9A;
    transform: translateX(-3px);
    box-shadow: 0 4px 12px rgba(90, 175, 154, 0.2);
}

.profileDetailsBackBtn:active {
    transform: translateX(-1px);
}

@media (max-width: 768px) {
    .profileDetailsHeaderBar {
        width: 95%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/ProfileDetailsPage/ProfileDetailsPage.css"],"names":[],"mappings":"AAEA;IACI,UAAU;IACV,wBAAwB;IACxB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI;QACI,UAAU;IACd;AACJ","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap\");\n\n.profileDetailsHeaderBar {\n    width: 90%;\n    margin: 0 auto 18px auto;\n    display: flex;\n    align-items: center;\n}\n\n.profileDetailsBackBtn {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    background-color: #0E1B1B;\n    color: #5AAF9A;\n    border: 1px solid #1E2D2D;\n    border-radius: 10px;\n    padding: 9px 18px;\n    font-family: \"Inter\", sans-serif;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);\n}\n\n.profileDetailsBackBtn:hover {\n    background-color: #142424;\n    color: #48D1CC;\n    border-color: #5AAF9A;\n    transform: translateX(-3px);\n    box-shadow: 0 4px 12px rgba(90, 175, 154, 0.2);\n}\n\n.profileDetailsBackBtn:active {\n    transform: translateX(-1px);\n}\n\n@media (max-width: 768px) {\n    .profileDetailsHeaderBar {\n        width: 95%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
